import { getApi } from "../apiCall";

export const getUserAccess = (token) => {
  let url = `${process.env.REACT_APP_API_URL}/access/getAll`;
  return getApi(url);
};

export const getUserProfile = (token) => {
  let url = `${process.env.REACT_APP_API_URL}/view/profile`;
  return getApi(url);
};

export const getTraderListById = (token, id) => {
  let url = `${process.env.REACT_APP_API_URL}/trader/getSelected?id=${id}`;
  return getApi(url);
};

export const getUserDetails = (token, type) => {
  let url = `${process.env.REACT_APP_API_URL}/${type}/get`;
  return getApi(url);
};

export const getUserAdminProfile = (token) => {
  let url = `${process.env.REACT_APP_API_URL}/company-admin/getAllUsers`;
  return getApi(url);
};
